import React from "react";

const PageIcon: React.FC = () => {
  return (
    <svg width="94" height="94" viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.39844 9.40039C9.39844 4.2087 13.6071 0 18.7988 0H56.4004L84.6016 28.2012V84.6035C84.6016 89.7952 80.3929 94.0039 75.2012 94.0039H18.7988C13.6071 94.0039 9.39844 89.7952 9.39844 84.6035V9.40039Z"
        fill="#155EEF"
      />

      <path
        opacity="0.3"
        d="M56.4004 0L84.6016 28.2012H65.8008C60.6091 28.2012 56.4004 23.9925 56.4004 18.8008V0Z"
        fill="white"
      />

      <g clipPath="url(#clip0_913_23356)">
        <path
          d="M30.0791 47H63.9205M30.0791 54.5203H63.9205M30.0791 62.0406H63.9205M30.0791 69.5609H56.4002"
          stroke="white"
          strokeWidth="3.52515"
          strokeLinecap="round"
          strokeLinejoin="round" />
      </g>

      <defs>
        <clipPath id="clip0_913_23356">
          <rect width="37.6016" height="37.6016" fill="white" transform="translate(28.1992 37.6016)" />
        </clipPath>
      </defs>
    </svg>


  )
}

export default PageIcon;
